import DataMapper from './DataMapper'
import UserHistoryRM from '../responsemodel/UserHistoryRM'
import UserHistory from '../../models/UserHistory'

export default class UserHistoryDataMapper extends DataMapper<UserHistoryRM, UserHistory> {
    map = (rm: UserHistoryRM) => new UserHistory(rm.id, rm.action, rm.actionBy, rm.date, rm.previousAddress, rm.previousCoordinates, rm.requestAddress, rm.requestCoordinates, rm.updatedCoordinates,rm.UpdatedAddress)
}
